<template>
  <div>
    <ListPage title="Campaigns" :headers="headers" :items="channels.items"
        :cols="4"
    >
      <template v-slot:actions>
        <v-btn text color="primary" @click="() => (newDialog = !newDialog)"
          ><v-icon>mdi-plus</v-icon> Add New
        </v-btn>
      </template>
      <template v-slot:card="{ item }">
        <AdTypeCardItem
          :value="item"
          @onDetails="onDetails"
        ></AdTypeCardItem>
      </template>

      <template v-slot:row="{ item, headers }">
        <AdTypeTableItem :value="item" :headers="headers"></AdTypeTableItem>
      </template>
    </ListPage>
    <!-- <NewInventoryItemDialog
      v-model="newInventoryItemDialog"
    ></NewInventoryItemDialog> -->
  </div>
</template>
  
  <script>
import ListPage from "../../../components/organisms/layout/ListPage.vue";
// import NewInventoryItemDialog from "./components/NewInventoryItemDialog.vue";
import AdTypeCardItem from "../../../components/organisms/adType/AdTypeCardItem.vue";
import AdTypeTableItem from "../../../components/organisms/adType/AdTypeTableItem.vue";
import { AdTypeAPIInstance } from "../../../api";

export default {
  data() {
    return {
      newDialog: false,
      headers: [
        { text: "ID", value: "id" },
        { text: "Status", value: "status" },
        { text: "Name", value: "name" },
        { text: "Code", value: "code" },
        { text: "Description", value: "description" },
        { text: "Created", value: "created_at" },
      ],
      channels: {
        items: [],
        pagination: {
          page: 1,
          pageSize: 10,
        },
      },
    };
  },
  computed: {},
  components: {
    AdTypeCardItem,
    AdTypeTableItem,
    ListPage,
    // NewInventoryItemDialog,
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const { items, pagination } = await AdTypeAPIInstance.list(
        this.channels.pagination
      );

      this.channels.items = items;
      this.channels.pagination = pagination;
    },

    onDetails(inventoryItem) {
      this.$router.push(`/campaigns/${inventoryItem.id}`, {
        params: { id: inventoryItem.id },
      });
    },
    onCreate(type) {
      this.$router.push(`/new-inventoryItem/${type.id}`);
    },
  },

  watch: {},
};
</script>
  
  
  <style lang="scss" scoped>
</style>